var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareBlockMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2299 5.60984C16.4168 4.79672 15.0985 4.79672 14.2854 5.60984L13.1252 6.76998C12.3121 7.58311 12.3121 8.90144 13.1252 9.71456L14.2854 10.8747C15.0985 11.6878 16.4168 11.6878 17.2299 10.8747L18.3901 9.71456C19.2032 8.90144 19.2032 7.58311 18.3901 6.76999L17.2299 5.60984ZM15.2669 6.59137C15.5379 6.32033 15.9774 6.32033 16.2484 6.59137L17.4085 7.75151C17.6796 8.02255 17.6796 8.46199 17.4085 8.73303L16.2484 9.89318C15.9774 10.1642 15.5379 10.1642 15.2669 9.89318L14.1067 8.73303C13.8357 8.46199 13.8357 8.02255 14.1067 7.75151L15.2669 6.59137Z",
    fill: "currentColor",
    fillOpacity: 0.72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08213 5.11914C5.9322 5.11914 5 6.05134 5 7.20127V9.2834C5 10.4333 5.9322 11.3655 7.08213 11.3655H9.16426C10.3142 11.3655 11.2464 10.4333 11.2464 9.2834V7.20127C11.2464 6.05134 10.3142 5.11914 9.16426 5.11914H7.08213ZM6.38809 7.20127C6.38809 6.81796 6.69882 6.50723 7.08213 6.50723H9.16426C9.54757 6.50723 9.8583 6.81796 9.8583 7.20127V9.2834C9.8583 9.66671 9.54757 9.97744 9.16426 9.97744H7.08213C6.69882 9.97744 6.38809 9.66671 6.38809 9.2834V7.20127Z",
    fill: "currentColor",
    fillOpacity: 0.72
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14.8357C5 13.6858 5.9322 12.7536 7.08213 12.7536H9.16426C10.3142 12.7536 11.2464 13.6858 11.2464 14.8357V16.9179C11.2464 18.0678 10.3142 19 9.16426 19H7.08213C5.9322 19 5 18.0678 5 16.9179V14.8357ZM7.08213 14.1417C6.69882 14.1417 6.38809 14.4524 6.38809 14.8357V16.9179C6.38809 17.3012 6.69882 17.6119 7.08213 17.6119H9.16426C9.54757 17.6119 9.8583 17.3012 9.8583 16.9179V14.8357C9.8583 14.4524 9.54757 14.1417 9.16426 14.1417H7.08213Z",
    fill: "currentColor",
    fillOpacity: 0.72
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7166 12.7536C13.5667 12.7536 12.6345 13.6858 12.6345 14.8357V16.9179C12.6345 18.0678 13.5667 19 14.7166 19H16.7987C17.9487 19 18.8809 18.0678 18.8809 16.9179V14.8357C18.8809 13.6858 17.9487 12.7536 16.7987 12.7536H14.7166ZM14.0226 14.8357C14.0226 14.4524 14.3333 14.1417 14.7166 14.1417H16.7987C17.182 14.1417 17.4928 14.4524 17.4928 14.8357V16.9179C17.4928 17.3012 17.182 17.6119 16.7987 17.6119H14.7166C14.3333 17.6119 14.0226 17.3012 14.0226 16.9179V14.8357Z",
    fill: "currentColor",
    fillOpacity: 0.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareBlockMove);
export default __webpack_public_path__ + "static/media/square-block-move.6f078edbbb126fa69331bedee0846803.svg";
export { ForwardRef as ReactComponent };